import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  isDevMode
} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UntypedFormBuilder, UntypedFormGroup, FormControl, UntypedFormArray, FormGroupDirective, Validators} from "@angular/forms";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {environment} from '../../environments/environment';
import {ActivatedRoute, Router} from "@angular/router";
import {PipelineStateService} from "../services/state-services/pipeline-state-service/pipeline-state.service";
import {Observable, of, Subject, Subscription, timer} from "rxjs";
import Stage from "../_global/Stage";
import Tool from "../_global/Tool";
import PipelineParams from "../_global/PipelineParams";
import {AlertServiceService} from "../services/alert-service/alert-service.service";
import {AlleleSearchService} from "../services/allele-search/allele-search.service";
import {PipelineService} from "../services/pipeline-service/pipeline.service";
import {Title} from "@angular/platform-browser";
import {Location} from "@angular/common";
import {SequenceParserService} from "../services/sequence-parser/sequence-parser.service";
import {PhbrCheckboxServiceService} from "../services/phbr-checkbox-service/phbr-checkbox-service.service";
import _ from "lodash";
import {columnListToObject} from "../util/convert-columns";
import onCsvDownloadAllClickedNew from "../util/on-csv-download";
import {catchError, debounce, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap} from "rxjs/operators";
// import * as sarsSampleData from "../services/data/t-cell-sample.json";
import * as phbrData from "../services/data/PHBR-sample.json";
import * as pipelineData from "../services/data/pipeline-example.json";
import {initPhbrTool} from "../services/state-services/default-stage-states";
import Columns from "../_global/Columns";

const API_URL = `${environment['api_url']}/api/v1/phbr`;

@Component({
  selector: 'app-phbr',
  templateUrl: './phbr.component.html',
  styleUrls: ['./phbr.component.scss']
  // providers: [PipelineStateService, PipelineService, SequenceParserService, AlleleSearchService, AlertServiceService]
})
export class PhbrComponent implements OnInit, OnDestroy, OnChanges {
  /** Pipeline form */
  @Input() formGroupName!: string
  @Input() index!: number;
  @Input() resultUrl!: string | undefined;
  @Input() emailForm!: UntypedFormGroup;

  @Output() emitIndex = new EventEmitter<number>(); // used for run all
  @Output() openEmailModal = new EventEmitter<any>();
  @Output() emitOnCancel = new EventEmitter<any>();

  // @ViewChild('alleleSearch') alleleSearch!: ElementRef;
  @ViewChild('alertModal') alertModal!: ElementRef;
  @ViewChild('confirmModal') confirmModal!: ElementRef;
  // @ViewChild('alleleModal') alleleModal!: ElementRef;

  @Input() events: Observable<void> = of();
  private eventsSubscription: Subscription  = new Subscription();

  @Input() runAllEvent: Observable<void> = of();
  private runAllSubscription: Subscription  = new Subscription();

  unsubscribe$ = new Subject();

  stages$: Observable<Stage[]> = this._stateService.stages$;
  tools$: Observable<Tool[]> = this._stateService.tools$;
  pipelineId$: Observable<string> = this._stateService.pipelineId$;
  params$: Observable<PipelineParams> = this._stateService.params$;

  stages: Stage[] = [];
  tools: Tool[] = [];
  pipelineId = '';
  params!: PipelineParams;

  /** Form variables */
  phbrForm!: UntypedFormGroup;
  // enableClassI = this._phbrCheckboxService.enableClassI;
  // enableClassII = this._phbrCheckboxService.enableClassII;

  enableAlleleA = true;
  enableAlleleB = true;
  enableAlleleC = true;

  enableAlleleDRB = true;
  enableAlleleDPA = true;
  enableAlleleDPB = true;
  enableAlleleDQA = true;
  enableAlleleDQB = true;

  modalOpen = false;

  /** neo-epitope files */
  maxCharacters = 1000000;
  files: any[] = [];
  fileName = '';

  /** sequence variables */
  synthesisDownloadLinks = {
    sequence_list_json_uri: '',
    sequence_list_fasta_uri: '',
    download_sequences: ''
  };

  swaggerUrl = `${environment['api_url']}/apidocs`



  /** Alleles */
  searchFailed = false;

  searching_a = false;
  searching_b = false;
  searching_c = false;

  searching_drb = false;
  searching_dpa = false;
  searching_dpb = false;
  searching_dqa = false;
  searching_dqb = false;

  pipelineUrl: string = ''

  phbrSampleData = phbrData

  inputChange = {
    /** Keeps track of inputChanges to highlight selected parameter table row*/
    inputNeoEpitopeText: false,
    alleles: false,
    // lengths: false,
    // peptideMutationPosition1: false,
    // peptideMutationPosition2: false,
    // frameshiftOverlap: false,
    // maximumPeptideLength: false,
    table_state: false,
    // table_state_2: false,
  }

  // GET PHBR
  mhciPredictors: any[] = [];
  predictionOptionsI: {display_name: string, short_name: string, group: string, source: string, has_ic50: boolean}[] = [];

  mhciiPredictors: any[] = [];
  predictionOptionsII: {display_name: string, short_name: string, group: string, source: string, has_ic50: boolean}[] = [];

  /** API Call variables */
  runSetInterval: any;
  submitted = false;
  loading = false;
  getResultsClicked = true;
  pipelineLoading = false;
  tableStateSaving = false;
  saveState = false;
  active = ''

  defaultOrder: any[] = [];

  errorMessages: string[] = [];
  warningMessages: string[] = [];
  closeResult = '';

  peptide_table_order: any[] = [];
  peptide_table_columns: Columns[] | any;
  peptide_table: [(string | number)[]] = [[]]

  constructor(
    public alertService: AlertServiceService,
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private _alleleSearchService: AlleleSearchService,
    private _pipelineService: PipelineService,
    private _stateService: PipelineStateService,
    private rootFormGroup: FormGroupDirective, // pipeline component
    // private route: ActivatedRoute,
    // private router: Router,
    // private titleService: Title,
    private location: Location,
    private sequenceParserService: SequenceParserService,
    public _phbrCheckboxService: PhbrCheckboxServiceService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.getPHBR()
    this.phbrForm = this.rootFormGroup.control.get(this.formGroupName) as UntypedFormGroup;

    this.pipelineId$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      console.log(`pipelineId=${value}`);
      this.pipelineId = value;
      this.pipelineUrl = `${window.location.origin}/pipeline/${value}`;
    })
    this.stages$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      console.log(value);
      this.stages = value;
      this.errorMessages = this.stages[this.index]?.stage_messages!.errors
      this.warningMessages = this.stages[this.index]?.stage_messages!.warnings

      /** Set checkboxes when data loads, else defaulted to `true`. */
      if(Object.keys(this.stages[this.index]?.input_parameters).length !== 0) {
        // this.enableClassI = !!this.stages[this.index]?.input_parameters.class_i;
        this._phbrCheckboxService.setI(!!this.stages[this.index]?.input_parameters.class_i);

        // this.enableClassII = !!this.stages[this.index]?.input_parameters.class_ii;
        this._phbrCheckboxService.setII(!!this.stages[this.index]?.input_parameters.class_ii);

        /** Set enableAllele checkboxes when data loads */
        this.enableAlleleA = !!this.stages[this.index]?.input_parameters?.class_i?.alleles.A;
        this.enableAlleleB = !!this.stages[this.index]?.input_parameters?.class_i?.alleles.B;
        this.enableAlleleC = !!this.stages[this.index]?.input_parameters?.class_i?.alleles.C;

        /**
         * DRB,
         DPA,
         DPB,
         DQA,
         DQB*/
        this.enableAlleleDRB = !!this.stages[this.index]?.input_parameters?.class_ii?.alleles.DRB;
        this.enableAlleleDPA = !!this.stages[this.index]?.input_parameters?.class_ii?.alleles.DPA;
        this.enableAlleleDPB = !!this.stages[this.index]?.input_parameters?.class_ii?.alleles.DPB;
        this.enableAlleleDQA = !!this.stages[this.index]?.input_parameters?.class_ii?.alleles.DQA;
        this.enableAlleleDQB = !!this.stages[this.index]?.input_parameters?.class_ii?.alleles.DQB;
        // console.log('enableAlleleDRB', this.stages[this.index]?.input_parameters?.class_ii?.alleles.DRB)
        // console.log('enableAlleleDRB', this.enableAlleleDRB)



      }

    })
    this.tools$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      console.log('tools$');
      console.log(value);
      this.tools = value;
      this.submitted = this.tools[this.index]?.submitted

      const inputSequenceTextId = this.tools[this.index]?.input_data_uri?.input_sequence_text_id

      this.synthesisDownloadLinks.sequence_list_json_uri = `${environment['api_url']}/api/v1/sequence_list_json/${inputSequenceTextId}`
      this.synthesisDownloadLinks.sequence_list_fasta_uri = `${environment['api_url']}/api/v1/sequence_list_fasta/${inputSequenceTextId}`
      this.synthesisDownloadLinks.download_sequences = `${environment['api_url']}/api/v1/download_sequences/${inputSequenceTextId}`

      // this.loading = this.tools[this.index]?.loading
      if(!this.tools[this.index]?.loading) {
        this.loading = false;
        clearInterval(this.runSetInterval)
      }

      /** pipeline Loading */
      this.pipelineLoading = _.some(this.tools, {loading: true})
      // if(this.pipelineLoading) {
      //   this.disableInputs();
      // } else {
      //   this.enableInputs();
      // }
      console.log('pipelineLoading')
      console.log(this.pipelineLoading)

    })

    this.params$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      console.log(`params`);
      console.log(value);
      this.params = value;
    })

    this.eventsSubscription = this.events.subscribe(() => this.onRunMain());
    this.runAllSubscription = this.runAllEvent.subscribe(() => this.onRunAll())

    this.onChanges();

  }

  ngOnDestroy() {
    clearInterval(this.runSetInterval);
    clearInterval(this._pipelineService.runSetInterval)
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    this.eventsSubscription.unsubscribe();
    this.runAllSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.resultUrl?.currentValue) {
      console.log(changes.resultUrl.currentValue);
      console.log('ngOnChanges t-cell')
      this.loading = true;
      this.getResultsSetInterval(changes.resultUrl.currentValue);
    }
  }

  get styleResultContainer(){
    return !this.loading && this.submitted ? 'none' : 'dotted';
  }

  get alleles() {
    return this.phbrForm.get('alleles') as UntypedFormArray;
  }

  /**
   *   enableAlleleA = true;
   *   enableAlleleB = true;
   *   enableAlleleC = true;
   *
   *   enableAlleleDRB = true;
   *   enableAlleleDPA = true;
   *   enableAlleleDPB = true;
   *   enableAlleleDQA = true;
   *   enableAlleleDQB = true;
   * */


  getPHBR() {
    // this.mhciLoading = true;
    this.http.get<any[]>(API_URL)
      .pipe().subscribe(
      resp => {
        /** class I */
        // @ts-ignore
        this.mhciPredictors = resp['predictors_i'];
        this.predictionOptionsI = _.filter(this.mhciPredictors, {'group': 'binding'});
        /** class II */
        // @ts-ignore
        this.mhciiPredictors = resp['predictors_ii'];
        this.predictionOptionsII = _.filter(this.mhciiPredictors, {'group': 'binding'});
        // this.basicProcessingPredictionOption = _.filter(this.mhciPredictors, {'group': 'binding', 'has_ic50': true})
        // this.processingOptions = _.filter(this.mhciPredictors, {'group': 'processing'});
        // console.log(this.processingOptions)
        // this.mhciLoading = false;
      }
    )
  }

  enableInputs() {
    // this.pepmatchForm.enable({emitEvent: false});
    // this.phbrForm.controls['bestMatch'].enable({emitEvent: false})
    // this.phbrForm.controls['proteome'].enable({emitEvent: false})
    // this.options = Object.assign({}, this.options, {disabled: false});
  }

  disableInputs() {
    // this.pepmatchForm.disable({emitEvent: false});
    // this.phbrForm.controls['bestMatch'].disable({emitEvent: false})
    // this.phbrForm.controls['proteome'].disable({emitEvent: false})
    // this.options = Object.assign({}, this.options, {disabled: true});
  }

  onChanges(): void {
    /** PredictionModel sessionStorage */
    // this.tCellForm.get('predictionModels')?.valueChanges.subscribe(val => {
    //   // sessionStorage.setItem('predictionModels', JSON.stringify(val));
    //   this.inputChange.predictors = this.submitted
    // });
    //
    // const sequenceFieldChange = this.tCellForm.get('inputSequenceText')?.valueChanges.pipe(
    //   debounce(v => timer(1000)),
    // );
    //
    // this.tCellForm.get('breakPeptides')?.valueChanges.subscribe(val => {
    //   this.peptideLengthSliderOptions = Object.assign({}, this.peptideLengthSliderOptions, {disabled: val});
    // })
    //
    // sequenceFieldChange?.subscribe(val => {
    //   console.log('sequenceFieldChange')
    //   // sessionStorage.setItem('sequences', val);
    //   this.sequenceParser(val);
    //   this.inputChange.input_sequence_text = this.submitted;
    //   if (val === '') {  // delete
    //     this.filteredSequences = [];
    //     this.numOfAA = 0;
    //     // this.alertService.clear();
    //     // this.myForm.patchValue({
    //     //   inputFormat: 0
    //     // });
    //   }
    // });
  }

  onRunConfirm() {
    let indicies = _.range(this.index + 1, this.stages.length)
    let initTool: Tool;
    console.log(indicies);
    _.forEach(indicies, i => {
      initTool = this.tools[i];
      const unSubmittedTool = {
        ...initTool,
        loading: false,
        submitted: false,
      }
      this._stateService.insertTool(unSubmittedTool, i);
    })
    this.saveState ? this.onSaveTableState() : this.onRunMain();
  }

  onRun() {
    /**
     Update pipeline State
     *
     * */
    /** Reset global datatables search ext */
    $.fn.dataTable.ext.search = [];

    const stage_number = this.index + 1;
    /** run_stage_range */
    const run_stage_range: [number, number] = [stage_number, stage_number]
    /** default formValue */
    this.setDefaultFormValues()
    /** Sequences */
    let sequences = this.phbrForm.value.inputNeoEpitopeText

    /** input parameters */
    const inputParameters = this._pipelineService.convertPHBRForm(
      this.phbrForm,
      this._phbrCheckboxService.enableClassI,
      this._phbrCheckboxService.enableClassII
    )

    /** Table State */
    console.log(this.stages)
    console.log(this.index)
    const { table_state } = this.stages[this.index];

    const newStage = {
      "stage_display_name": "PHBR",
      "stage_number": stage_number,
      "stage_type": "prediction",
      "tool_group": "phbr",
      "input_neoepitopes": sequences,
      "input_parameters": inputParameters,
      "table_state": table_state
    }

    const params = {
      "pipeline_id": '',
      "pipeline_title": this.emailForm.controls['name'].value,
      "email": this.emailForm.controls['email'].value,
      "run_stage_range": run_stage_range,
      "stages": [
        newStage
      ]
    }

    /** set params */
    const loadingTool = Object.assign(initPhbrTool, {
      loading: true,
      submitted: false,
      appliedFilters: !_.isEmpty(table_state?.columns)
    })
    this._stateService.setParams(params);
    this._stateService.insertTool(loadingTool, this.index);
    this._stateService.insertInputParametersToStage(inputParameters, this.index);

    // this._stateService.insertTableStateToStage({columns: {}}, this.index);

    this.postPipelineAPI(params);
  }

  postPipelineAPI(params: PipelineParams, getResults: boolean = true) {
    /**
     * params
     * getResults: boolean
     *  false - used in 'Save Table State'
     * */
    /** initial set up */
    this.disableInputs();
    if (getResults) {
      this.errorMessages = [];
      this.warningMessages = [];
    }
    this.loading = getResults; // true - defaults
    this.submitted = !getResults; // false - defaults
    this.tableStateSaving = !getResults
    // this.residue_table_order = [];
    // this.residue_table_columns = null;
    // this.residue_table = [[]]
    //
    // this.sequence_table = [[]]
    // this.allele_distances_table = [[]]
    // this.residue_table = [[]]
    // this.peptide_table = [[]]
    // this.processingPlots = []

    console.log(params)

    this._pipelineService.postPipeline(params).subscribe(
      (resp) => {
        // Errors and Warnings
        if (resp['errors'] && resp['errors'].length) {
          console.log(resp);
          console.error(resp['errors']);
          this.errorMessages = resp['errors'];
          if (resp['warnings'].length) {
            console.log(resp['warnings']);
            this.warningMessages = resp['warnings'];
          }
          this.loading = false;
          this.submitted = true;
          const submittedTCellPredictionTool = Object.assign(initPhbrTool, {
            submitted: false,
            loading: false,
          })
          this._stateService.insertTool(submittedTCellPredictionTool, this.index);
          this.enableInputs();
          return;
        }
        // Warnings
        if (resp['warnings'].length) {
          console.log(resp['warnings']);
          this.warningMessages = resp['warnings'];
        }

        // TODO: don't use input_sequence_text -> 'input_neoepitopes_text'
        const inputDataUri = {input_sequence_text_id: resp.input_sequence_text_id}
        this._stateService.insertInputDataUriToTool(inputDataUri, this.index)

        this._stateService.setPipelineId(resp.pipeline_id);
        this._stateService.setPipelineIdToParams(resp.pipeline_id);
        this._stateService.setPipelineSpecId(resp.pipeline_spec_id);
        /** Display email Modal if emailModalShow=true */
        this.location.go(`pipeline/${resp.pipeline_id}`)
        // this.titleService.setTitle(`IEDB NG Tools Pipeline`);

        // this.location.replaceState(`pipeline/${resp.pipeline_id}`)
        // this.router.createUrlTree([`pipeline/${resp.pipeline_id}`])
        if (getResults) {
          const result_url = `${resp.results_uri}`;
          console.log(result_url);
          this.getResultsSetInterval(result_url);
        } else {
          this.inputChange.table_state = false;
          this.submitted = true;
          this.loading = false;
          this.tableStateSaving = false;
          this.enableInputs();
        }
      },
      (error) => {
        console.error(error);
        this.errorMessages.push(error.error);
        this.submitted = false;
        this.loading = false;
        const prevTool = this.tools[this.index];
        const submittedTool = Object.assign(prevTool, {
          submitted: this.submitted,
          loading: this.loading,
        })
        this._stateService.insertTool(submittedTool, this.index);
        clearInterval(this.runSetInterval);
        this.enableInputs();
      }
    )
  }

  onRunAll() {
    this.setDefaultFormValues()
    this.emitIndex.emit(this.index);
  }

  onRunMain() {
    if(this.phbrForm.invalid){
      this.open(this.alertModal)
      return;
    }

    const hasResult = _.find(this.tools.slice(this.index+1), (o) => o.submitted || o.loading)
    if(this.stages.length > 1 && hasResult) {
      this.open(this.confirmModal);
    } else {
      this.getResultsClicked = true;
      if(this.index===0) {
        this.onRun();
      } else {
        // this.onRun2()
      }
    }
  }

  setDefaultFormValues(
    alleleA1 = 'HLA-A*02:01',
    alleleA2 = 'HLA-A*01:02',
    alleleB1 = 'HLA-B*07:02',
    alleleB2 = 'HLA-B*07:03',
    alleleC1 = 'HLA-C*06:02',
    alleleC2 = 'HLA-C*06:04',
    alleleDRB1 = 'HLA-DRB1*01:01',
    alleleDRB2 = 'HLA-DRB1*01:15',
    alleleDPA1 = 'HLA-DPA1*01:03',
    alleleDPA2 = 'HLA-DPA1*01:03',
    alleleDPB1 = 'HLA-DPB1*03:01',
    alleleDPB2 = 'HLA-DPB1*04:02',
    alleleDQA1 = 'HLA-DQA1*01:01',
    alleleDQA2 = 'HLA-DQA1*01:03',
    alleleDQB1 = 'HLA-DQB1*02:01',
    alleleDQB2 = 'HLA-DQB1*06:32',
  ) {
    /** defaults */
    let seq: string = ''

    // if(environment.production || environment['name'] === 'DEV') { // prod or dev
    //   const {input_neoepitopes_text } = phbrSampleData; // correct examples
    //   seq = input_neoepitopes_text
    //
    // } else {
    //   const {input_neoepitopes_text } = phbrSampleData; // correct examples
    //   seq = input_neoepitopes_text
    //
    // }

    const {input_neoepitopes_text } = phbrData; // correct examples
    seq = input_neoepitopes_text

    /** Sequences */
    let sequences = this.phbrForm.value.inputNeoEpitopeText
    if(!sequences && this.index===0) {
      this._stateService.setInputSequenceText(seq);
      this.phbrForm.controls.inputNeoEpitopeText.setValue(seq);
    }

    /** Alleles */
    const patchValues = (allele: string, synonym = '', score = null) => {
      /** patchValues - helper function */
      return {
        label: allele,
        synonym: synonym,
        score: score
      }
    }
    /** A, B, C */
    if(this._phbrCheckboxService.enableClassI) {
      /** Allele A */
      alleleA1 = this.phbrForm.getRawValue().alleleA1?.label ? this.phbrForm.getRawValue().alleleA1.label : alleleA1;
      alleleA1 = this.enableAlleleA ? alleleA1 : '';
      console.log('alleleA1 HELLO', alleleA1)
      this.phbrForm.controls.alleleA1.setValue(patchValues(alleleA1));

      alleleA2 = this.phbrForm.getRawValue().alleleA2?.label ? this.phbrForm.getRawValue().alleleA2.label : alleleA2;
      alleleA2 = this.enableAlleleA ? alleleA2 : '';
      this.phbrForm.controls.alleleA2.setValue(patchValues(alleleA2));

      /** Allele B */
      alleleB1 = this.phbrForm.getRawValue().alleleB1?.label ? this.phbrForm.getRawValue().alleleB1.label : alleleB1;
      alleleB1 = this.enableAlleleB ? alleleB1 : '';
      this.phbrForm.controls.alleleB1.setValue(patchValues(alleleB1));

      alleleB2 = this.phbrForm.getRawValue().alleleB2?.label ? this.phbrForm.getRawValue().alleleB2.label : alleleB2;
      alleleB2 = this.enableAlleleB ? alleleB2 : '';
      this.phbrForm.controls.alleleB2.setValue(patchValues(alleleB2));

      /** Allele C */
      alleleC1 = this.phbrForm.getRawValue().alleleC1?.label ? this.phbrForm.getRawValue().alleleC1.label : alleleC1;
      alleleC1 = this.enableAlleleC ? alleleC1 : '';
      this.phbrForm.controls.alleleC1.setValue(patchValues(alleleC1));

      alleleC2 = this.phbrForm.getRawValue().alleleC2?.label ? this.phbrForm.getRawValue().alleleC2.label : alleleC2;
      alleleC2 = this.enableAlleleC ? alleleC2 : '';
      this.phbrForm.controls.alleleC2.setValue(patchValues(alleleC2));

    }
    else {
      /** If Class I is disabled, set alleles A, B, C to empty */
      this.phbrForm.controls.alleleA1.setValue(patchValues(''));
      this.phbrForm.controls.alleleA2.setValue(patchValues(''));
      this.phbrForm.controls.alleleB1.setValue(patchValues(''));
      this.phbrForm.controls.alleleB2.setValue(patchValues(''));
      this.phbrForm.controls.alleleC1.setValue(patchValues(''));
      this.phbrForm.controls.alleleC2.setValue(patchValues(''));
    }


    /** DRB, DPA, DPB, DQA, DQB */
    if (this._phbrCheckboxService.enableClassII) {
      /** Allele A */
      // alleleA1 = this.phbrForm.getRawValue().alleleA1?.label ? this.phbrForm.getRawValue().alleleA1.label : alleleA1;
      // alleleA1 = this.enableAlleleA ? alleleA1 : '';
      // console.log('alleleA1 HELLO', alleleA1)
      // this.phbrForm.controls.alleleA1.setValue(patchValues(alleleA1));

      /** DRB */
      alleleDRB1 = this.phbrForm.getRawValue().alleleDRB1?.label ? this.phbrForm.getRawValue().alleleDRB1.label : alleleDRB1;
      alleleDRB1 = this.enableAlleleDRB ? alleleDRB1 : '';
      this.phbrForm.controls.alleleDRB1.setValue(patchValues(alleleDRB1));

      alleleDRB2 = this.phbrForm.getRawValue().alleleDRB2?.label ? this.phbrForm.getRawValue().alleleDRB2.label : alleleDRB2;
      alleleDRB2 = this.enableAlleleDRB ? alleleDRB2 : '';
      this.phbrForm.controls.alleleDRB2.setValue(patchValues(alleleDRB2));

      /** DPA */
      alleleDPA1 = this.phbrForm.getRawValue().alleleDPA1?.label ? this.phbrForm.getRawValue().alleleDPA1.label : alleleDPA1;
      alleleDPA1 = this.enableAlleleDPA ? alleleDPA1 : '';
      this.phbrForm.controls.alleleDPA1.setValue(patchValues(alleleDPA1));
      alleleDPA2 = this.phbrForm.getRawValue().alleleDPA2?.label ? this.phbrForm.getRawValue().alleleDPA2.label : alleleDPA2;
      alleleDPA2 = this.enableAlleleDPA ? alleleDPA2 : '';
      this.phbrForm.controls.alleleDPA2.setValue(patchValues(alleleDPA2));
      /** DPB */
      alleleDPB1 = this.phbrForm.getRawValue().alleleDPB1?.label ? this.phbrForm.getRawValue().alleleDPB1.label : alleleDPB1;
      alleleDPB1 = this.enableAlleleDPB ? alleleDPB1 : '';
      this.phbrForm.controls.alleleDPB1.setValue(patchValues(alleleDPB1));
      alleleDPB2 = this.phbrForm.getRawValue().alleleDPB2?.label ? this.phbrForm.getRawValue().alleleDPB2.label : alleleDPB2;
      alleleDPB2 = this.enableAlleleDPB ? alleleDPB2 : '';
      this.phbrForm.controls.alleleDPB2.setValue(patchValues(alleleDPB2));

      /** DQA */
      alleleDQA1 = this.phbrForm.getRawValue().alleleDQA1?.label ? this.phbrForm.getRawValue().alleleDQA1.label : alleleDQA1;
      alleleDQA1 = this.enableAlleleDQA ? alleleDQA1 : '';
      this.phbrForm.controls.alleleDQA1.setValue(patchValues(alleleDQA1));
      alleleDQA2 = this.phbrForm.getRawValue().alleleDQA2?.label ? this.phbrForm.getRawValue().alleleDQA2.label : alleleDQA2;
      alleleDQA2 = this.enableAlleleDQA ? alleleDQA2 : '';
      this.phbrForm.controls.alleleDQA2.setValue(patchValues(alleleDQA2));
      /** DQB */
      alleleDQB1 = this.phbrForm.getRawValue().alleleDQB1?.label ? this.phbrForm.getRawValue().alleleDQB1.label : alleleDQB1;
      alleleDQB1 = this.enableAlleleDQB ? alleleDQB1 : '';
      this.phbrForm.controls.alleleDQB1.setValue(patchValues(alleleDQB1));
      alleleDQB2 = this.phbrForm.getRawValue().alleleDQB2?.label ? this.phbrForm.getRawValue().alleleDQB2.label : alleleDQB2;
      alleleDQB2 = this.enableAlleleDQB ? alleleDQB2 : '';
      this.phbrForm.controls.alleleDQB2.setValue(patchValues(alleleDQB2));
    }
    else {
      /** If Class I is disabled, set alleles A, B, C to empty */
      this.phbrForm.controls.alleleDRB1.setValue(patchValues(''));
      this.phbrForm.controls.alleleDRB2.setValue(patchValues(''));
      this.phbrForm.controls.alleleDPA1.setValue(patchValues(''));
      this.phbrForm.controls.alleleDPA2.setValue(patchValues(''));
      this.phbrForm.controls.alleleDPB1.setValue(patchValues(''));
      this.phbrForm.controls.alleleDPB2.setValue(patchValues(''));
      this.phbrForm.controls.alleleDQA1.setValue(patchValues(''));
      this.phbrForm.controls.alleleDQA2.setValue(patchValues(''));
      this.phbrForm.controls.alleleDQB1.setValue(patchValues(''));
      this.phbrForm.controls.alleleDQB2.setValue(patchValues(''));
    }
  }

  /** Confirm Modal Functions */
  open(content: any) {
    this.modalOpen = true;
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      animation: true,
      backdrop: 'static'
    }).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
      this.saveState = false;
      this.modalOpen = false;
    }, (reason) => {
      this.saveState = false;
      // this.alleleSearch.nativeElement.focus();
      // this.closeResult = `Dismissed ${TCellPredictionComponent.getDismissReason(reason)}`;
    });
  }

  /** Download Sequence File API calls
   * onDownloadJson()
   * onDownloadFasta()
   * onDownloadOriginal()
   * */

  onDownloadJson() {
    onCsvDownloadAllClickedNew(this.synthesisDownloadLinks.sequence_list_json_uri, this.http, 'json');
  }

  onDownloadFasta() {
    onCsvDownloadAllClickedNew(this.synthesisDownloadLinks.sequence_list_fasta_uri, this.http, 'fasta');
  }

  onDownloadOriginal() {
    onCsvDownloadAllClickedNew(this.synthesisDownloadLinks.download_sequences, this.http, 'txt');
  }

  onDownloadParameter() {
    const data = this._pipelineService.convertPHBRForm(this.phbrForm)

    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    // const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-16';
    // var blob = new Blob([csvData], { type: contentType });
    const blob = new Blob([JSON.stringify(data, null, 2)], ); // thx: http://stackoverflow.com/a/18925211
    a.href = window.URL.createObjectURL(blob);
    a.download = 'parameter.json';

    a.click();
  }

  /** File Download/Upload*/
  uploadSequenceFile($event: any) {
    // TODO: add file upload
    $event.preventDefault();
    /**
     * Used for 'Upload' button
     * */
    const {files} = $event.target;
    // files && this.onFileDropped(files);
  }

  onFileDropped($event: any[]) {
    // TODO: need to add bottom
    console.log($event);
    const file = $event[0];
    const fileSize = file.size / 1024; // in kB
    console.log(file.type);
    // if (fileSize > 20000) {
    //   this.alertService.add('File Size is too big! (20mB max)', 'alert-danger');
    //   this.open(this.alertModal);
    // } else if(file.type==='application/x-gzip') {
    //   console.log('GZIPPED')
    //   this.prepareGzipFileList($event)
    // } else {
    //   this.prepareSequenceFileList($event);
    // }
  }

  onAlleleSelect({e, input}: { e: any, input: any }) {
    e.preventDefault();
    const selectedAllele = e.item;
    let labels = _.map(this.alleles.value, (allele) => allele.label)
    if (!labels.includes(selectedAllele.label)) {
      this.alleles.push(this.fb.group(selectedAllele));
    }
    // sessionStorage.setItem('selectedAlleles', JSON.stringify(this.selectedAlleles));
    input.value = '';
  }



  resultFormatter = (result: any) => {
    /**
     *  The function that converts an item from the result list to a string to display in the popup.
     * */
    return result.synonyms.length > 0 ? `${result.label} - (${result.synonyms})` : result.label;
  }

  inputFormatter(value: any): any {
    /**
     * The function that converts an item from the result list to a string to display in the <input> field.
     * */
    if (value.label) {
      return `${value.label}`;
    }
  }

  /** Allele Typeahead Search Functions */

  searchAlleleA = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_a = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-A').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_a = false)
    )

  searchAlleleB = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_b = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-B').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_b = false)
    )

  searchAlleleC = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_c = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-C').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_c = false)
    )


  searchAlleleDRB = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_drb = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-DRB').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_drb = false)
    )

  searchAlleleDPA = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_dpa = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-DPA').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_dpa = false)
    )

  searchAlleleDPB = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_dpb = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-DPB').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_dpb = false)
    )

  searchAlleleDQA = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_dqa = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-DQA').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_dqa = false)
    )

  searchAlleleDQB = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap(() => this.searching_dqb = true),
      switchMap(term => {
          // console.log(term);
          return this._alleleSearchService.search(term, 'phbr', 'HLA-DQB').pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        }
      ),
      tap(() => this.searching_dqb = false)
    )
  onSaveTableStateMain() {
    const hasResult = _.find(this.tools.slice(this.index+1), {submitted: true})
    if (hasResult) {
      this.saveState = true;
      this.open(this.confirmModal);
    } else {
      this.onSaveTableState();
    }
  }

  onSaveTableState() {
    const tool_group = 'phbr'

    const params = this.params
    // create colObj and params
    let colObj = columnListToObject(this.peptide_table_columns, tool_group)
    const stages = params.stages;
    const stageTemp = stages[this.index];

    stageTemp.table_state = [{table: 'peptide_table', columns: colObj}];
    stages[this.index] = stageTemp
    params.stages = stages;
    // run_stage_range
    const stage_number = this.index + 1;
    params.run_stage_range = [stage_number, stage_number];
    this._stateService.setParams(params);
    // appliedFilters
    let appliedFilters = !_.isEmpty(colObj);
    this._stateService.setToolAppliedFilters(appliedFilters, this.index)
    this.postPipelineAPI(params, false);
    this.saveState = false;
  }

  onFilterApplied() {
    this.inputChange.table_state = this.submitted;
  }

  onClearTableState() {
    this.peptide_table_columns = _.map(this.peptide_table_columns, (c) => {
      c.value_limits = c.type === 'int'? {
          minValue: NaN,
          maxValue: NaN,
          applied: false
        } :
        {
          possibleValues: [],
          textValue: null,
          selectedValues: [],
          applied: false
        }
      return c
    })
    this.inputChange.table_state = this.submitted;
  }

  onCancel() {
    console.log(this.runSetInterval)
    clearInterval(this.runSetInterval);
    this.emitOnCancel.emit()

    this.inputChange.table_state = false;

    const currentTool = this.tools[this.index];
    const unSubmittedTool = {
      ...currentTool,
      loading: false,
      submitted: false,
      appliedFilters: undefined
    }
    this._stateService.insertTool(unSubmittedTool, this.index);
    this.warningMessages = [];
    this.loading = false;
    this.tableStateSaving = false;
    this.enableInputs();
  }


  getResultsSetInterval(result_url: string)
  {
    /** */
    this.getResultsClicked = true

    // this.residue_table_order = [];
    // this.residue_table_columns = null;
    // this.residue_table = [[]]
    //
    // this.sequence_table = [[]]
    // this.allele_distances_table = [[]]
    // this.residue_table = [[]]
    // this.snp_table = [[]]
    // this.processingPlots = []

    this.peptide_table = [[]]

    this.resultUrl = result_url;
    console.log(result_url)
    this.inputChange = _.mapValues(this.inputChange, () => false);
    let increment = 0;
    const milliseconds = 3000;
    this.runSetInterval = setInterval(() => {
      this._pipelineService.getResults(`${result_url}?statusOnly=true`).subscribe(
        {
          next: resp => {
            console.log(resp);
            if (resp['status'] === 'error' || resp['errors']) {
              // this.errorMessages = resp['errors'];
              // this.warningMessages = resp['warnings'];
              this.submitted = false;
              this.loading = false;
              const prevTool = this.tools[this.index];
              const submittedTool = Object.assign(prevTool, {
                submitted: this.submitted,
                loading: this.loading,
              })
              this._stateService.insertTool(submittedTool, this.index);
              clearInterval(this.runSetInterval);
              this.enableInputs();
            }
            if (resp['data']['warnings']?.length) {
              // console.log(resp['warnings']);
              this.warningMessages = resp['data']['warnings'];
            }
            if (resp['data']['errors']?.length) {
              // console.log(resp['warnings']);
              this.errorMessages = resp['data']['errors'];
            }

            if (resp['status'] === 'done') {
              clearInterval(this.runSetInterval);

              this._pipelineService.getResults(result_url).subscribe(resp => {
                // clearInterval(this.runSetInterval);
                console.log(resp)
                this.defaultOrder = [[]]
                /** 1) Create Column */
                const data = resp['data']['results'];
                // check for residue_table
                this.active = data[0].type
                _.forEach(data, table => {

                  if (table.type === 'peptide_table') {
                    this.peptide_table_columns = _.map(table.table_columns, (column, i) => {
                      if (column.default_order && Number.isFinite(column.row_sort_priority)) { // set defaultOrder
                        this.defaultOrder[column.row_sort_priority] = [i, column.default_order === "ascending" ? 'asc' : 'desc'];
                      }
                      column['title'] = `${column['display_name']}`; // required
                      column['data'] = `${column['name']}`;
                      let source = column['source'];

                      column['filterKey'] = `${source}.${column.name}`

                      // console.log(`source=${source}`);
                      let tempSource = source.split('.')
                      // console.log(tempSource);
                      source = tempSource[tempSource.length - 1];
                      // console.log(`source=${source}`);
                      column['data'] = `${source}_${column['name']}`;
                      /** remove `core` from name */
                      // column['name'] = column['display_name'] ? column['display_name'] : column['name']

                      column['value_limits'] = column['value_limits'] &&  this.setValueLimits(column)

                      // console.log(column['value_limits'])
                      // column['value_limits'] = column['value_limits'] ? {...column['value_limits'], applied: false, possibleValues: []} : undefined

                      return column
                    });

                    // TODO - uncomment this when 'this.defaultOrder' actually contains values
                    // this.peptide_table_order = [...this.defaultOrder];
                    if (this.peptide_table_columns) {
                      this.peptide_table = table.table_data;
                    }
                    console.log(this.peptide_table_order);
                    console.log(this.peptide_table_columns);
                    console.log(this.peptide_table);
                  }


                })

                this.submitted = true; this.loading = false;
                const prevTool = this.tools[this.index];
                console.log(prevTool)
                const submittedTool = Object.assign(prevTool, {
                  submitted: this.submitted,
                  loading: this.loading,
                })
                this._stateService.insertTool(submittedTool, this.index);
                // clearInterval(this.runSetInterval); // remove later
                console.log(data);
                console.log(resp.pipeline_id)
                this.enableInputs();
              })
            }
            if (resp['status'] === 'canceled') {
              /** if status is canceled, then just stop loader **/
              this.submitted = false;
              this.loading = false;
              const prevTool = this.tools[this.index];
              console.log(prevTool)
              const submittedTCellPredictionTool = Object.assign(prevTool, {
                submitted: this.submitted,
                loading: this.loading,
              })
              this._stateService.insertTool(submittedTCellPredictionTool, this.index);
              clearInterval(this.runSetInterval);
              // console.log(data);
              this.enableInputs();
              // set error message
              // this.errorMessages = [`PIPELINE_ID=${this.pipelineId} w/ STATUS=${resp['status']}`]
            }
            else {
              this.getResultsClicked = false;
              console.log(`current status: ${resp['status']} - ${increment}`);
              increment += 1;
            }
          },
          error: error => {
            console.error(error);
            this.enableInputs();
            clearInterval(this.runSetInterval);
            this.loading = false;
          }
        }
      )
    }, milliseconds);
  }

  setValueLimits(column: Columns) : any {
    /* set value_limits (i.e. filters) for each column based on if type is a number/string */
    return column['type'] === 'int' || column['type'] === 'float' ? {
      ...column['value_limits'],
      minValue: NaN,
      maxValue: NaN,
      applied: false
    } : {
      // ...column['value_limits'],
      possibleValues: column['value_limits']['unique_values'],
      textValue: null,
      selectedValues: [],
      applied: false
    }
  }

  onReset() {
    // TODO - at the bottom, need to configure this.inputChange
    this.alertService.clear();
    this.errorMessages = [];
    this.warningMessages = [];

    const oldSequence = this.stages[this.index].input_sequence_text
    const input_parameters = this.params.stages[this.index].input_parameters

    console.log(input_parameters)


    // this.filteredSequences = [];
    // this.numOfAA = 0;
    // order
    this.peptide_table_order = [];
    this.defaultOrder = [];
    /** phbr form values */

    this.phbrForm.patchValue({
      inputNeoEpitopeText: '',
      predictionMethodI: 'netmhcpan_el',
      alleleA1: {label: ''},
      alleleA2: {label: ''},
      alleleB1: {label: ''},
      alleleB2: {label: ''},
      alleleC1: {label: ''},
      alleleC2: {label: ''},
      predictionMethodII: 'netmhciipan_el-4.3',
      alleleDRB1: {label: ''},
      alleleDRB2: {label: ''},
      alleleDPA1: {label: ''},
      alleleDPA2: {label: ''},
      alleleDPB1: {label: ''},
      alleleDPB2: {label: ''},
      alleleDQA1: {label: ''},
      alleleDQA2: {label: ''},
      alleleDQB1: {label: ''},
      alleleDQB2: {label: ''},
    }, {emitEvent: false});
    //
    // // selected alleles
    // this.alleles.clear()
    //
    // // predictors
    // const initPredictor = {
    //   type: 'binding',
    //   method: 'netmhcpan_el',
    // }
    // const pm = this.tCellForm.controls.predictionModels as UntypedFormArray
    // pm.clear({emitEvent: false})
    // pm.push(this.fb.group(initPredictor), {emitEvent: false});
    //
    // this.enableInputs();
    //
    if(this.submitted){
      this.inputChange =  {
        ...this.inputChange,
        /** Keeps track of inputChanges to highlight selected parameter table row*/
        inputNeoEpitopeText: oldSequence !== '',
        // alleles: !_.isEqual([], input_parameters.alleles),
        // lengths: !_.isEqual(peptideLength, input_parameters.peptide_length_range),
        // predictors: !_.isEqual([initPredictor], input_parameters.predictors),
      }
    }
  }
}
